// extracted by mini-css-extract-plugin
export default {"user_avatar":"AvatarSelect_user_avatar__1-MLT","avatar_row":"AvatarSelect_avatar_row__bFavL","avatar":"AvatarSelect_avatar__ebdUh","avatar_edit":"AvatarSelect_avatar_edit__r8PKR"};